import script from "./CompareRadarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareRadarChart.vue?vue&type=script&setup=true&lang=js"

import "./CompareRadarChart.vue?vue&type=style&index=0&id=7c836f10&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c836f10"]])

export default __exports__